import apiClient from '@/services/axios'

export async function post(venueId) {
  var response = await apiClient.post('/EodReports', { venueId });
  if (response) {
    return response.data
  }

  throw new Error('Unable to add eod report')
}